export default __webpack_public_path__ + "static/media/OMSC_05.1d43864b.gif";